import { useState, useEffect } from "react";
import { db } from "../firebase/config";
import { collection, query, onSnapshot, where } from "firebase/firestore";

export const useFetchEnabledHours = (
    docCollection,
    professional,
    date
) => {

    const [documents, setDocuments] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);

        if (professional === '' || date === '') {
            setDocuments([]);
            setLoading(false);
            return;
        }

        const collectionRef = collection(db, docCollection);
        const q = query(
            collectionRef,
            where("date", "==", date),
            where("professional", "==", professional)
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            setDocuments(
                querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }))
            );
            setLoading(false);
        }, (e) => {
            setError(e);
            setDocuments([]);
            setLoading(false);
        });

        return unsubscribe;
    }, [docCollection, professional, date])

    return { documents, loading, error };
};
